(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryDeleteController',SectorCategoryDeleteController);

    SectorCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'SectorCategory'];

    function SectorCategoryDeleteController($uibModalInstance, entity, SectorCategory) {
        var vm = this;
        vm.sectorCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SectorCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
